// Used only by the old Spotlight (SpotlightOLD.tsx), restyled in ResultsDropdown/StyledComponents.tsx.
// Delete with the redesign feature flag (discover_spotlight_redesign_phase_0).
import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import { useNavigableItem } from '../../KeyboardNavigation';
import type { AfterSelectAction } from '../../KeyboardNavigation/types';
import { getSpotlightResultClassName } from '../../helpers/getSpotlightResultClassName';

interface Props {
	dataId: string;
	dataSrc?: string;
	children: React.ReactNode;
	onSelect: () => void;
	afterSelect?: AfterSelectAction;
	className?: string;
}

export function Item({ dataId, dataSrc, children, onSelect, afterSelect, className }: Props) {
	const { isActive, itemRef, select } = useNavigableItem<HTMLLIElement>(onSelect, {
		afterSelect,
	});

	const classNames = [getSpotlightResultClassName('GENERIC'), className]
		.filter(Boolean)
		.join(' ');

	return (
		<StyledLI
			$isActive={isActive}
			data-id={dataId}
			data-src={dataSrc}
			onClick={select}
			className={classNames}
			ref={itemRef}
		>
			{children}
		</StyledLI>
	);
}

export const StyledLI = styled.li<{ $isActive: boolean }>`
	${({ $isActive }) => $isActive && `background-color: ${token.gray25};`}
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${token.spacing4};
	width: 100%;
	padding: ${token.spacing3} ${token.spacing5};
	cursor: pointer;

	&:hover {
		background-color: ${token.gray25};
	}
`;
